import BpkInfoBanner, {
  ALERT_TYPES,
  STYLE_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-info-banner';
import { useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';

export const PriceDisclaimerBanner = () => {
  const { translate } = useTranslations();

  return (
    <BpkInfoBanner
      message={translate('travel_confidence_map_price_disclaimer')}
      type={ALERT_TYPES.INFO}
      style={STYLE_TYPES.ON_CONTRAST}
    />
  );
};
